import React, { useState } from "react";

// Package Import
import {
  Box,
  Typography,
  Grid,
  Menu,
  MenuItem,
  Fade,
  Paper,
  useTheme,
  TextField,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Divider,
  Chip,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Pagination,
  Stack,
} from "@mui/material";
import { formControlClasses } from "@mui/material/FormControl";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { menuClasses } from "@mui/material/Menu";

import { Add as AddIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";

// User Import

import { headersPost } from "../../../../Services/API";
import { MINISTRY_API_ULRS } from "../../../../Services/Routes/API";
import { RoutesUrls } from "../../../../Services/Routes/APP";
import { USER_ROLES_ENUM } from "../../../../common/Enums";

// Component

const UnitsUsed = () => {
  // Hooks

  const theme = useTheme();
  const navigate = useNavigate();

  const handleClose = () => {
    setAnchorEl(null);
  };

  //States

  const [anchorEl, setAnchorEl] = useState(null);

  // Constants

  const openMenu = Boolean(anchorEl);

  // Render
  return (
    <Paper
      sx={{
        p: 2,
        margin: "auto",

        borderRadius: 2,
      }}
    >
      <Box padding={2}>
        <Typography
          width={"100%"}
          variant="h5"
          fontWeight={"bold"}
          display={"flex"}
          justifyContent={"center"}
          color={"text.grayText"}
          sx={{
            textTransform: "uppercase",
            paddingBottom: 2,
          }}
        >
          Units Used
        </Typography>

        <Box padding={{ xs: 2, sm: 3, md: 5 }}>
          <Grid
            container
            justifyContent={"space-around"}
            spacing={2}
            margin={"auto"}
            maxWidth={250}
          >
            <Grid container marginBottom={5}>
              <TextField
                variant="outlined"
                size={"small"}
                type={"text"}
                name="name"
                placeholder="Select Inventory"
                fullWidth
                sx={{
                  border: "1px solid grey",
                  [`& .${outlinedInputClasses?.root}`]: {
                    borderRadius: theme.spacing(4),
                  },
                  [`&.${formControlClasses?.root}`]: {
                    border: "none",
                  },
                }}
              />

              <Menu
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleClose}
                TransitionComponent={Fade}
                sx={{
                  [`& .${menuClasses.root}`]: {
                    paddingRight: 4,
                    paddingLeft: 4,
                  },
                }}
              >
                <MenuItem>Add Inventory</MenuItem>
                <Divider />
                <MenuItem>Units Used</MenuItem>
                <Divider />
                <MenuItem>Transfer Batch</MenuItem>
                <Divider />

                <MenuItem>Request Inventory</MenuItem>
              </Menu>
            </Grid>

            <Grid container marginBottom={5}>
              <TextField
                variant="outlined"
                size={"small"}
                fullWidth
                name="email"
                type={"email"}
                placeholder="Select Type"
                sx={{
                  border: "1px solid grey",
                  [`& .${outlinedInputClasses?.root}`]: {
                    borderRadius: theme.spacing(4),
                  },
                  [`&.${formControlClasses?.root}`]: {
                    border: "none",
                  },
                }}
              />
            </Grid>
            <Grid container marginBottom={5}>
              <TextField
                variant="outlined"
                size={"small"}
                fullWidth
                name="email"
                type={"email"}
                placeholder="Batch#"
                sx={{
                  border: "1px solid grey",
                  [`& .${outlinedInputClasses?.root}`]: {
                    borderRadius: theme.spacing(4),
                  },
                  [`&.${formControlClasses?.root}`]: {
                    border: "none",
                  },
                }}
              />
            </Grid>

            <Grid container>
              <TextField
                variant="outlined"
                size={"small"}
                placeholder="Quantity Used"
                name="population"
                type={"text"}
                fullWidth
                sx={{
                  border: "1px solid grey",
                  [`& .${outlinedInputClasses?.root}`]: {
                    borderRadius: theme.spacing(4),
                  },
                  [`&.${formControlClasses?.root}`]: {
                    border: "none",
                  },
                }}
              />
              <Grid
                container
                marginTop={5}
                display={"flex"}
                justifyContent={"center"}
              >
                <Button
                  variant="contained"
                  type="submit"
                  size="large"
                  margin={"auto"}
                  sx={{
                    borderRadius: "37px !important",
                    minWidth: "20%",
                  }}
                  //   startIcon={<AddIcon />}
                >
                  Done
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/* <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar> */}
    </Paper>
  );
};

export default UnitsUsed;
